module.exports = __webpack_public_path__ + "static/img/game-type-dcpxdcg.85408ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-type-dcpxdcg.png
// module id = Q0eG
// module chunks = 1